/**
 * Single source of truth for ProNet team members.
 * Used by: About page, Blog articles, and any other place that references staff.
 */

export const TEAM_ROLE = "Sales Officer";

export const TEAM = [
  {
    name:  "Anastasia Brul",
    phone: "+971 52 577 90 99",
    email: "anastasia.brul@pronet-realestate.com",
    photo: "/team/anastasia.jpg",
    pos:   "center 15%",
    role:  TEAM_ROLE,
  },
  {
    name:  "Tatiana Ustiuzhanina",
    phone: "+971 58 216 53 77",
    email: "tatiana@pronet-realestate.com",
    photo: "/team/tatiana-u.png",
    pos:   "center 10%",
    role:  TEAM_ROLE,
  },
  {
    name:  "Tatiana Aratskaia",
    phone: "+971 58 565 30 39",
    email: "info@pronet-realestate.com",
    photo: "/team/tatiana-a.png",
    pos:   "center 8%",
    role:  TEAM_ROLE,
  },
  {
    name:  "Ksenia Usher",
    phone: "+971 50 972 33 58",
    email: "ksenia.u@pronet-realestate.com",
    photo: "/team/ksenia.png",
    pos:   "center 5%",
    role:  TEAM_ROLE,
  },
  {
    name:  "Irina Khayrutdinova",
    phone: "+971 50 516 23 68",
    email: "irina.khayrutdinova@pronet-realestate.com",
    photo: "/team/irina.jpg",
    pos:   "center 12%",
    role:  TEAM_ROLE,
  },
];

/**
 * Find a team member by name.
 * @param {string} name
 * @returns {typeof TEAM[0] | undefined}
 */
export const findMember = (name) => TEAM.find((m) => m.name === name);
